/**
 @ngdoc directive
 @name candidate

 @description
 candidate widget that allows to add candidates into candidate table and formModel for submissions

 @usage
 <candidate
 label="Candidate"
 new-candidate-model="pageModel.newCandidate"
 candidates-model="formModel.candidates"
 ></candidate>

 @param {label}               string           - label that's used across widget
 @param {ew-candidate-model}  model            - Angularjs model that's used to collect new candidate data
 @param {candidates-model}    model            - Angularjs model that's used to collect candidates data

 */

(function() {
    'use strict';
    var candidateDirective = function ($templateCache, ajaxCall, i18nService, xmsNotificationFactory) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: true,
            bindToController: {
                label:"@",
                newCandidateModel: "=",
                candidatesModel: "="
            },
            controllerAs: "ctrl",
            template: $templateCache.get('formWidget/candidate.html'),
            controller: ['$scope', function($scope){

                var _this = this;

                this.$onInit = function(){
                    _this.newCandidateModel = {};
                    _this.candidatesModel = [];
                    _this.anonymisationLevels = [];
                    _this.MAX_CANDIDATES = 10;
                    _this.i18nService = i18nService.preLoadI18nValues({
                        'default.candidateWidget.candidate.label': 'Candidate',
                        'default.candidateWidget.cv.label': 'CV',
                        'default.candidateWidget.anonymisation.label': 'Candidate Anonymisation Level (applies to all selected candidates)',
                        'default.candidateWidget.comments.label': 'Blurb',
                        'default.candidateWidget.searchFor.label': 'Search for',
                        'default.candidateWidget.preview.label': 'Preview',
                        'default.candidateWidget.missingFields.label': 'Please fill in all the mandatory fields.',
                        'default.candidateWidget.remove.label': 'Remove',
                        'default.candidateWidget.maxCandidatesWarningTitle.label': 'Maximum number of candidates added.',
                        'default.candidateWidget.maxCandidatesWarningInfo.label': 'You must remove one or more candidate(s) before adding another.',
                        'default.candidateWidget.pleaseSelect.label': 'Please Select',
                        'default.candidateWidget.comments.info.label': 'Changes made to the candidate Blurb here will not be saved to the candidate record.',
                        'default.candidateWidget.anonymisationWarning.label': 'Please note that this anonymisation will only be applied to the email body; text within the CV will not be changed',
                        'default.candidateWidget.noCandidates.label': 'You must add at least one candidate.'
                    });

                    getAnonymisationLevels();
                };

                /**
                 * Function that sets the anonymistion levels array to the scope
                 */
                function getAnonymisationLevels() {
                    var ajaxUrl = WEBAPP_PATH + '/candidate/getAnonymisationLevels';
                    ajaxCall.getData(ajaxUrl).then(
                        function(result) {
                            $scope.anonymisationLevels = result.data;
                        },
                        function(result) {
                            var errorMessage = "Error: " + result.status + ' -  failed to load anonymisation levels';
                            xmsNotificationFactory.add('getAnonymisationLevels', 'danger', errorMessage, 5);
                        }
                    );
                };

                /**
                 * Check whether candidate has cvs and return warning
                 */
                $scope.checkCVErrors = function() {
                    if ($scope.pageModel.newCandidate.candidate.cvs.length < 1) {
                        xmsNotificationFactory.add('getCvContentErrorMessage', 'warning', 'No CVs found for ' + _this.newCandidateModel.candidate.value , 5);
                    }
                };

                /**
                 * Function that adds candidate to candidate table into formModel
                 * @param candidate
                 */
                $scope.addCandidate = function(candidate) {
                    if (!(candidate.candidate.userAttributeTags != undefined && candidate.candidate.userAttributeTags.indexOf("CANDIDATE_ENGAGEMENT_EMAIL") >= 0)) {
                        xmsNotificationFactory.add('addCandidate', 'warning', 'This candidate does not have the required attribute in order to complete this action. Please add this to the candidate record:<br/>Candidate Engagement Email');
                    } else if (!$scope.invalidNewCandidateForm()) {
                        _this.candidatesModel.push(candidate);
                        reset();
                    }
                };

                /**
                 * Removing candidate from candidate table and formMOdel
                 * @param index
                 */
                $scope.removeCandidate = function(index) {
                    _this.candidatesModel.splice(index, 1);
                };

                /**
                 * Validation function
                 * @returns {*|boolean}
                 */
                $scope.invalidNewCandidateForm = function(){
                    return ($scope.newCandidateForm.$invalid || (Object.keys(_this.newCandidateModel).length === 0));
                };

                /**
                 * function that resets the new candidate model based on selected candidate information
                 */
                $scope.autoCompleteChanged = function (){
                    if (_this.newCandidateModel.candidate == null) {
                        reset();
                    }
                };

                /**
                 * Reset function that clears new candidate model
                 */
                var reset = function (){
                    _this.newCandidateModel = {};
                };
            }],
            require: ['^form','candidate']
        };
    };

    candidateDirective.$inject = ['$templateCache', 'ajaxCall', 'i18nService', 'xmsNotificationFactory'];
    angular.module('app').directive('candidate', candidateDirective);

}());
